import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/files-7252442_1920.jpeg";

function GamlePDFerTilgjengelige() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.gamlePDFerTilgjengelige.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.gamlePDFerTilgjengelige.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/gamle-pdf-er-tilgjengelige"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.description")}
          </p>
          <p className="text-lg text-secondary">
           {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.date")}
          </p>
        </div>
        <img
          src={article_img}
          className="w-full md:w-2/5"
          alt={i18next.t("pages.articles.list.gamlePDFerTilgjengelige.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.archive.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.archive.content")}
              <a href="/docengine" className=" underline hover:text-contrast-ink">
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.archive.link")}
              </a>
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.archive.content2")}
            </p>
           

            <h3 className="text-xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.capabilities.title")}
            </h3>
            <ul className="list-disc list-outside ml-6">
              <li>{i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.capabilities.features.1")}</li>
              <li>{i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.capabilities.features.2")}</li>
              <li>{i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.capabilities.features.3")}</li>
              <li>{i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.capabilities.features.4")}</li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.opportunity.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.opportunity.content")}
            </p>

            
            <p className="font-bold">
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.contact.content")}
              <a href="/skjema/kontakt-oss" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.contact.link")}
              </a>
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.sections.contact.content2")}
            </p>


          </div>
        </div>
      </div>
    </div>
  );
}

export default GamlePDFerTilgjengelige;
